import './HomeShowContent.css';
import p1 from './res1.gif';
import p2 from './res2.png';
import p3 from './res3.png';
import p4 from './res4.png';
import p5 from './res5.png';
import back from './left.png';
import front from './right.png'; 
import { useEffect, useState } from 'react';

let HomeShowContent=()=>{

    // make array of all pics what you want to show-------------------------------
    let arry = [p1, p2, p3, p4, p5];

    let [allpics, setallpics] = useState(arry);
    let [selectedpic, setselectedpic] = useState(0);   
    
let backfun=()=>{
    if(selectedpic == 0){
        setselectedpic(allpics.length-1)
    }else{
        setselectedpic(selectedpic - 1)
    }
    
}

let frontfun=()=>{
    if(selectedpic == allpics.length -1){
        setselectedpic(0)
    }else{
        setselectedpic(selectedpic + 1)
    }

}

// useEffect(()=>{
//     setInterval(()=>{
//         setselectedpic(selectedpic=> selectedpic >= allpics.length -1 ? 0 : selectedpic + 1)  
//     }, 5000)
// }, [])


    return(
        <div className='mainshowcont'>
            <div className='pic'>       
                <p className='frst_caption'>Caption {selectedpic +1}</p>
                <img className='frst_img' src={allpics[selectedpic]}/> 
            </div>
            <span title='back' className='first btn'><img onClick={backfun} className='back' src={back}/></span>
            <span title='front' className='second btn'><img className='front' onClick={frontfun}  src={front}/></span>

           
        </div>
    );
}
export default HomeShowContent;